import { render, staticRenderFns } from "./ModalPeriod.vue?vue&type=template&id=6afc2f50&scoped=true&"
import script from "./ModalPeriod.vue?vue&type=script&lang=js&"
export * from "./ModalPeriod.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6afc2f50",
  null
  
)

export default component.exports